module.exports = __webpack_public_path__ + "img/Success Order.15ce0d6b.svg";